
const appBarHeight = 100
const appDrawerWidthMobile = 350
const catalogDrawerWidth = 420
const catalogDrawerWidthMobile = 350
const viewerDrawerWidth = 500
const ordersDrawerWidth = 500

export {
  appBarHeight,
  appDrawerWidthMobile,
  catalogDrawerWidth,
  catalogDrawerWidthMobile,
  viewerDrawerWidth,
  ordersDrawerWidth
}
